"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEspoolChildConfigurationModel = exports.espoolChildConfigurationModelUseableDef = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const KetteConfigurationModel_1 = require("./KetteConfigurationModel");
exports.espoolChildConfigurationModelUseableDef = {
    parent: KetteConfigurationModel_1.ketteConfigurationModelUseableDef,
    validation: {
        ChildRelation: (value) => (value === null || value === void 0 ? void 0 : value.Position) in echain_shared_articles_1.EspoolChainPosition,
        Kette: true,
        Espool: false,
    },
};
exports.isEspoolChildConfigurationModel = echain_shared_modelling_1.UseableUtil.createGuard(exports.espoolChildConfigurationModelUseableDef);
//# sourceMappingURL=EspoolChildConfigurationModel.js.map